import { IMetadataApi } from '../../providers/metadata.provider';

let pluginMetadataApi: IMetadataApi | undefined;

/**
 * Features such as the DataMapper read and write files through an `IMetadataApi` supplied by
 * the host. The self-hosted web app has no host to ask, so an installed extension can supply
 * one; without it those features stay unavailable, exactly as before.
 */
export const registerPluginMetadataApi = (api: IMetadataApi): void => {
  pluginMetadataApi = api;
};

export const getPluginMetadataApi = (): IMetadataApi | undefined => pluginMetadataApi;

export const clearPluginMetadataApi = (): void => {
  pluginMetadataApi = undefined;
};
